var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"flex items-center",attrs:{"tag":"span","to":{name: 'chat'}}},[_c('feather-icon',{staticClass:"cursor-pointer mr-4 transform scale-100",attrs:{"icon":"MessageCircleIcon","badge":_vm.unseenMsg}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }